module.exports = __webpack_public_path__ + "static/img/1.03637e2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news17/1.png
// module id = 1vB/
// module chunks = 1